import React, { useState } from 'react';
import { post } from '../../../../../Model/Network/Config/Axios';
import { GinLink } from './GinLink';
import { handleError, showToast } from '../../../../Common/fToast/ToastCallback';
import ButtonOutline from '../../../../Common/fCard/ButtonOutline';
import { KeyValue } from '../../../../Common/Components/KeyValue';

export const Gin = ({ id, reload,ginDetails={},ginInvoiceTagging }) => {
    const [link, setLink] = useState(false)
    const [loading,setLoading] = useState(false)
    

    const onLink = (ginId) => {
        post(`vendor/procurement/gin/ginInvoiceMapping/${ginId}`, { invoiceId: Number(id) }, (e, r) => {
            if (r) {
                showToast({
                    type: 'success',
                    message: 'Gin linked to invoice successfully'
                })
                setLink(false)
                reload()
                setLoading(false)
            } else {
                handleError(e)
                setLoading(false)
            }
        })
    }

    return (
        <div id="Invoice_Format" className='FadeRight-Effect' style={{ position: 'relative', paddingBottom: 100 }}>
            <div style={{ justifyContent: 'space-between', display: 'flex', paddingBottom: '20px', alignItems: 'center' }}>
                <div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>
                    GIN
                </div>
                {ginInvoiceTagging &&
                    <ButtonOutline
                        loading={loading}
                        style={{ margin: '15px 5px' }}
                        title="Link GIN"
                        onClick={() => setLink(true)}
                    />
                }
            </div>
            <div style={{ marginTop: '10px' }}>
                <KeyValue title="GIN" value={ginDetails.ginId} />
                <KeyValue title="Status" value={ginDetails.status} />
            </div>
            {Object.keys(ginDetails).length > 0 &&
                <div style={{
                    boxShadow: 'rgb(1 1 1 / 2%) 4px 5px 3px',
                    cursor: 'pointer',
                    border: '1px solid var(--border-color)',
                    borderRadius: 8,
                    fontSize: 12,
                    textAlign: 'center',
                    padding: '10px 12px',
                    color: "#000",
                }} onClick={() => {
                  window.open(`/app/vendor/gin/${ginDetails.id}`,'_blank')
                }}>
                    View more details
                </div>
                }
            {link && <GinLink onClose={() => setLink(false)} onLink={onLink} />}
        </div>
    )
}